import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2004"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M0 11.758s5.837-.185 6.688-3.165c.834-2.919-2.461-4.063-4.144-3.39-1.309.523-1.409 1.551-1.305 1.85 0 0 2.976-1.199 3.365 1.048C5.009 10.451 0 11.758 0 11.758z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12.139 3.959c-1.375-3.316-6.282-.756-6.282-.756s4.48-.842 4.294 2.597-6.096 6.298-9.526 7.197c0 0 5.545-.449 8.377-2.458 2.832-2.008 4.018-4.455 3.137-6.58z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M15.975 5.813c-.33-3.664-4.08-3.806-4.08-3.806s4.332 3.607.571 7.584c-4.179 4.42-11.267 3.971-11.005 4.049 1.927.57 7.005.485 9.877-.941 2.723-1.352 4.919-3.754 4.637-6.886z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }